import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';
import { Box, Typography } from '@material-ui/core';

import { Blurred, Translation } from '../../common';

export const HEADER_KEY = 'HEADER';
export const DESCRIPTION_KEY = 'SUBHEADER';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
    background:
      'radial-gradient(117.92% 200% at 106.25% 153.75%, #AC2BED 0%, #540FC9 23.17%, #AC2BED 100%)',
    boxSizing: 'border-box'
  },
  rootMobile: {
    padding: '26px 16px'
  },
  title: {
    textAlign: 'center',
    color: theme.palette.primary.contrastText
  },
  description: {
    marginTop: 16,
    textAlign: 'center',
    color: theme.palette.background.default
  }
}));

const PayNow = ({ isTabletSize, isMobileSize, blur }) => {
  const classes = useStyles();

  return (
    <Box
      className={classNames(classes.root, isMobileSize && classes.rootMobile)}
    >
      <Blurred blur={blur}>
        <Typography
          className={classes.title}
          variant={isTabletSize || isMobileSize ? 'h3' : 'h2'}
          component="h2"
        >
          <Translation inline>{HEADER_KEY}</Translation>
        </Typography>
        {!isMobileSize && (
          <Typography
            className={classes.description}
            variant="body1"
            component="p"
          >
            <Translation inline>{DESCRIPTION_KEY}</Translation>
          </Typography>
        )}
      </Blurred>
    </Box>
  );
};

PayNow.propTypes = {
  isTabletSize: PropTypes.bool,
  isMobileSize: PropTypes.bool,
  blur: PropTypes.bool
};

export default PayNow;
